module.exports = __webpack_public_path__ + "img/domain.bff22b39.png";